import { ESuggestedPortfolioBuilderSteps } from './types';

import { GoalDate } from '../components/GoalDate';
import { InitialInvestment } from '../components/InitialInvestment';
import { PortfolioSelect } from '../components/PortfolioSelect';
import { PortfolioDetails } from '../components/PortfolioDetails';
import { Conclusion } from '../components/Conclusion';
import { HandleError } from '../components/HandleError';

export const CreateSuggestedPortfolioComponents = {
  [ESuggestedPortfolioBuilderSteps.GOAL_DATE]: GoalDate,
  [ESuggestedPortfolioBuilderSteps.INITIAL_INVESTMENT]: InitialInvestment,
  [ESuggestedPortfolioBuilderSteps.PORTFOLIO_SELECT]: PortfolioSelect,
  [ESuggestedPortfolioBuilderSteps.DETAILS]: PortfolioDetails,
  [ESuggestedPortfolioBuilderSteps.CONCLUSION]: Conclusion,
  [ESuggestedPortfolioBuilderSteps.ERROR]: HandleError
};
